import { ITypedModel } from 'core-ts-types';
import { Model } from 'utility-ts-orm';
import { APAlternatePlanDetailsSlot } from '../builders/ap_alternate_plan_details_slot_builder';

export interface IAlternatePlanComparePlanEntry {
  id: number;
  slots: APAlternatePlanDetailsSlot[];
}

export interface IAlternatePlanComparePlans {
  from?: IAlternatePlanComparePlanEntry;
  to?: IAlternatePlanComparePlanEntry;
}

export type alternate_plan_complete_keys = 'from' | 'to';

export type AlternatePlanComparePlansModel = ITypedModel<IAlternatePlanComparePlans>;

angular.module('capability-ng-academic-planner').factory(
  'ngAlternatePlanComparePlansModel',
  (): AlternatePlanComparePlansModel =>
    new Model<IAlternatePlanComparePlans>({
      from: undefined,
      to: undefined
    })
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/alternate_plans/models/alternate_plan_compare_plans_model.ts